import React from 'react'
import { ImLab } from "react-icons/im";
import { IoMdApps } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { AiOutlineSearch } from "react-icons/ai";
import { MdMicNone } from "react-icons/md";
import { MdOutlineCropFree } from "react-icons/md";

export default function Google() {
  return (
    <div>

      <div className="flex items-center space-x-2 justify-between text-sm sm:flex sm:justify-between mt-3">
        <div className="flex justify-start space-x-2 ml-2 sm:flex sm:justify-start sm:space-x-6 sm:ml-3">
          <div className="c">About</div>
          <div className="c">Store</div>
        </div>
        <div className="flex justify-end space-x-2 mr-3 sm:ml-6 sm:flex sm:justify-end items-center sm:space-x-6 sm:mr-3">
          <div className="c">Gmail</div>
          <div className="c">Images</div>
          <div className="size-[20px] sm:size-[30px] rounded-full flex justify-center items-center cursor-pointer duration-500 hover:bg-slate-300"><ImLab /></div>
          <div className="size-[20px] sm:size-[30px] rounded-full flex justify-center items-center cursor-pointer duration-500 hover:bg-slate-300"><IoMdApps /></div>
          <div className="size-[20px] sm:size-[30px] rounded-full flex justify-center items-center cursor-pointer duration-500 hover:bg-slate-300"><CgProfile /></div>
        </div>
      </div>

      <div className="mr-6 sm:flex sm:justify-center mt-9">
        <span className='font-serif font-bold text-3xl sm:text-6xl text-blue-600'>G</span>
        <span className='font-serif font-bold text-3xl sm:text-6xl text-red-500'>o</span>
        <span className='font-serif font-bold text-3xl sm:text-6xl text-yellow-400'>o</span>
        <span className='font-serif font-bold text-3xl sm:text-6xl text-blue-600'>g</span>
        <span className='font-serif font-bold text-3xl sm:text-6xl text-green-600'>l</span>
        <span className='font-serif font-bold text-3xl sm:text-6xl text-red-500'>e</span>
      </div>

      <div className="flex justify-center mt-16">
        <div className="w-[300px] sm:w-[600px]">
          <div className="border rounded-full relative">
            <input className='p-1 w-[100%] sm:p-3 rounded-full bg-slate-300 ' type="text" placeholder='' />
            <AiOutlineSearch className='top-2 left-2 absolute sm:top-4 sm:left-4 sm:text-1xl cursor-pointer' />
            <MdMicNone className='top-2 right-9 absolute sm:top-4 sm:right-12 sm:text-1xl cursor-pointer' />
            <MdOutlineCropFree className='top-2 right-2 absolute sm:top-4 sm:right-4 sm:text-1xl cursor-pointer' />
          </div>
        </div>
      </div>

      <div className="flex justify-center sm:flex sm:justify-center space-x-9 mt-7">
        <div className="text-sm p-1 sm:border bg-slate-300 sm:p-1">
          Google Search
        </div>
        <div className="text-sm sm:border bg-slate-300 p-1">
          I'm Feeling Lucky
        </div>
      </div>

      <div className="flex justify-center flex-wrap text-sm sm:flex sm:justify-center space-x-2 mt-7">
        <div className="">
          Google offered in:
        </div>
        <div className="text-blue-950">
          English
        </div>
        <div className="text-blue-950">
          Hindi
        </div>
        <div className="text-blue-950">
          Spanish
        </div>
        <div className="text-blue-950">
          Korean
        </div>
        <div className="text-blue-950">
          Japanese
        </div>
        <div className="text-blue-950">
          German
        </div>
        <div className="text-blue-950">
          Chinese
        </div>
        <div className="text-blue-950">
          Malta
        </div>
        <div className="text-blue-950">
          Aussie
        </div>
      </div>

      <div className="mt-56 sm:mt-80 bg-slate-300">
        <div className="justify-center text-sm  sm:flex sm:justify-start border-b-slate-900  ml-5 shadow-2xl">
          <div className="c">India</div>
        </div>
        <hr className='border-white' />
        <div className=" mt-3 sm:flex sm:justify-between sm:items-center ml-5 mr-5 sm:mt-2 ">
          <div className="flex columns-1 justify-center text-sm sm:flex sm:justify-start sm:items-center sm:text-1xl space-x-5">
            <div className="c">Advertising</div>
            <div className="c">Bussiness</div>
            <div className="c">HowSearchWorks</div>
          </div>
          <div className="flex justify-center columns-1 mt-3 text-sm sm:flex sm:justify-end sm:items-center sm:mt-0 sm:text-1xl space-x-5">
            <div className="c">Privacy</div>
            <div className="c">Terms</div>
            <div className="c">Settings</div>
          </div>
        </div>
      </div>



    </div>
  )
}
